import React from 'react'
import { Button } from '@gate/gui'
import { Flex } from '@mantine/core'
import { useAdapter } from '@/components/Adapter'
import { useTranslation } from 'next-i18next'
import { EnumPriceTopTitleTab } from '@/blocks/Price/PriceBanner'
import { eventTracker } from '@/utils/collectEvent'

interface MoreTipProps {
  handleModalVisible: () => void
  tabs: EnumPriceTopTitleTab
}

const MoreTip: React.FC<MoreTipProps> = ({ tabs, handleModalVisible }) => {
  const { isH5 } = useAdapter()

  const { t } = useTranslation()

  const onClick = () => {
    handleModalVisible()
    eventTracker('price_overview_click', {
      button_name: 'market_more',
      button_type: tabs === EnumPriceTopTitleTab.MarketToday ? 'market_today' : 'weekly_recap',
    })
  }

  return (
    <Flex justify="center" style={{ marginTop: isH5 ? 24 : 0 }}>
      <Button
        onClick={onClick}
        size="sm"
        type="outlined"
        label={t('P.More') as string}
        className="text-1 size-14 font-500"
      />
    </Flex>
  )
}

export default MoreTip
